import {useEffect, useState } from "react";
import {
  ChartDataParams,
  FormatChartData,
} from "../../../../../../components/recharts/functions";
import { ReMixChart } from "../../../../../../components/recharts/ReMixCharts";
import { BrushStart, ChartType } from "../../../../../../models/chart_model";
import { renderHourTick } from "../../../../../../components/recharts/components";
import { R_CHART_TYPES } from "../../../../Utility/const";
import loader from "../../../../../../components/recharts/loader.gif";
import { getMonthFromDate } from "../../../../../../extensions/date";
interface SummaryData {
  date: string;
  month: string;
  oar: number;
  gna_cost: number;
  gna_quantum: number;
  tgna_cost: number;
  tgna_quantum: number;
  optimal_gna: number;
  total_cost: number;
  slot: number;
}
export default function MonthVolumeAnalysis({
  selectedBlock,
  refreshKey,
  setError,
  loading,
  data,
}: {
  selectedBlock: any[];
  refreshKey: number;
  setError?: any;
  loading: boolean;
  data: SummaryData[];
}) {
  const [chartData, setChartData] = useState<any[]>([]);
  const [chartKeys, setChartKeys] = useState<any[]>([]);
  const chartSuffixes = [
    {
      suffix: "tgna_quantum",
      displayName: "Optimal TGNA Utilisation",
      stackSuffix: "tgna_quantum",
      stroke: "rgba(255, 194, 158, 1)",
      chartType: ChartType.Bar,
      unit: "MW",
      yAxisId: "left",
    },
    {
      suffix: "gna_quantum",
      displayName: "Optimal GNA Utilisation",
      stackSuffix: "gna_quantum",
      stroke: "rgba(241, 147, 92, 1)",
      chartType: ChartType.Bar,
      unit: "MW",
      yAxisId: "left",
    },
    {
      suffix: "optimal_gna",
      displayName: "Optimal GNA",
      stackSuffix: "optimal_gna",
      stroke: "rgba(52, 101, 109, 1)",
      chartType: ChartType.Line,
      unit: "MW",
      yAxisId: "left",
      isDash:true
    },
    {
      suffix: "oar",
      displayName: "Total Open Access Requirement",
      stackSuffix: "oar",
      stroke: "rgba(17, 141, 255, 1)",
      chartType: ChartType.Line,
      unit: "MW",
      yAxisId: "left",
    },
  ];
  const [selectedMetrics] = useState<any[]>([
    chartSuffixes[0],
    chartSuffixes[1],
    chartSuffixes[2],
    chartSuffixes[3],
  ]);
  const [selectedChartType] = useState(R_CHART_TYPES[1]);

  useEffect(() => {
    let filteredData = data;
    // if (selectedBlock.length > 0) {
    //   const blocks = selectedBlock.map((b: any) => Number(b.value ?? b));
    //   filteredData = filteredData.filter((row) =>
    //     blocks.includes(Number(row.time_slot))
    //   );
    // }

    // if (selectedGeneratorName.length > 0) {
    //   const generator = selectedGeneratorName.map((o: any) => o.value ?? o);
    //   filteredData = filteredData.filter((row) =>
    //     generator.includes(row.generator)
    // );
    // }

    const par: ChartDataParams = {
      keys: ["date", "slot", "month"],
      tableKeys: ["date", "slot", "month"],
      groupBy: [""],
      volumeKey: ``,
      aggregationKeys: ["gna_quantum", "tgna_quantum", "optimal_gna", "oar"],
      averageKeys: [],
      averageDuplicationKeys: ["date", "slot", "month"],
      priceKey: "",
      data: filteredData,
    };

    const cData = FormatChartData(par);
    setChartData(cData.data);
    setChartKeys(cData.keys);
  }, [data, selectedBlock]);

  const createChartObject = (
    key: string,
    index: number,
    suffix: string,
    displayName: string,
    stackSuffix: string,
    chartType: ChartType,
    unit: string,
    stroke: string,
    legendColor: string,
    yAxisId: string,
    isDash:boolean
  ) => {
    return {
      dataKey: `${key}_${suffix}`,
      name: `${key.replace("_", " ").replace("undefined", "")} ${displayName}`,
      legendColor: legendColor,
      type: ["optimal_gna", "oar"].includes(suffix)
        ? ChartType.Line
        : selectedChartType.value,
      unit: unit,
      stroke: stroke,
      yAxisId: yAxisId,
      stackId: undefined,
      isDash:isDash
    };
  };

  function getLegends() {
    return selectedMetrics.flatMap(
      ({
        suffix,
        displayName,
        stackSuffix,
        chartType,
        unit,
        yAxisId,
        stroke,
        legendColor,
        isDash
      }) =>
        chartKeys.map(
          (key, index) =>
            createChartObject(
              key,
              index,
              suffix,
              displayName,
              stackSuffix,
              chartType,
              unit,
              stroke,
              legendColor,
              yAxisId,
              isDash
            ) as any
        )
    );
  }

  return (
    <>
      {loading ? (
        <div className="w-full bg-white flex items-center justify-center">
          <img
            src={loader}
            width={200}
            alt="loader"
            className="block mt-[5rem]"
          />
        </div>
      ) : (
        <ReMixChart
          chartHeight="calc(100% - 50px)"
          data={chartData}
          showBrush={chartData.length > 96 * 2 ? true : undefined}
          brushStart={BrushStart.Start}
          isTimeSlot={false}
          onlyTitle={true}
          legends={getLegends()}
          yAxisLabel="MW"
          // secondYAxisLabel="₹/kWh"
          nameGap={40}
          xDataKey={"month"}
          top={10} // Top margin for grid
          bottom={30} // Bottom margin for grid
          xTick={(value: any, index: any) => {
            return renderHourTick(value, 10);
          }}
          // secondXDataKey={"month"}
          showToolbox={false}
        />
      )}
    </>
  );
}
